/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddServiceQuotationDocumentRequest,
  AddServiceQuotationScopeOfWorkRequest,
  CancelServiceQuotationRequest,
  CloseServiceQuotationRenegotiationRequest,
  DownloadServiceQuotationDocumentParams,
  DownloadServiceQuotationProposalsComparisonParams,
  EntitiesServiceQuotationActionResult,
  EntitiesServiceQuotationActivityLog,
  EntitiesServiceQuotationDetail,
  EntitiesServiceQuotationDocument,
  EntitiesServiceQuotationIssueListResponse,
  EntitiesServiceQuotationListResponse,
  EntitiesServiceQuotationPossibleActions,
  EntitiesServiceQuotationVendorInvitationResult,
  InviteServiceQuotationVendorsRequest,
  ListServiceQuotationsForIssuanceParams,
  ListServiceQuotationsParams,
  OpenServiceQuotationRenegotiationRequest,
  RefuseServiceQuotationRequest,
  ReopenServiceQuotationOfferWindowRequest,
  RequestServiceQuotationAnticipationRequest,
  UpdateServiceQuotationRequest
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List service quotations
 */
export const listServiceQuotations = (
    params?: ListServiceQuotationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationListResponse>(
      {url: `/api/v3/service_quotations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListServiceQuotationsInfiniteQueryKey = (params?: ListServiceQuotationsParams,) => {
    return [
    'infinite', `/api/v3/service_quotations`, ...(params ? [params] : [])
    ] as const;
    }

export const getListServiceQuotationsQueryKey = (params?: ListServiceQuotationsParams,) => {
    return [
    `/api/v3/service_quotations`, ...(params ? [params] : [])
    ] as const;
    }


export const useListServiceQuotationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotations>>> = ({ signal }) => listServiceQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotations>>>
export type ListServiceQuotationsInfiniteQueryError = ErrorType<unknown>


export function useListServiceQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotations>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotations>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations
 */

export function useListServiceQuotationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service quotations
 */
export const prefetchListServiceQuotationsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListServiceQuotationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListServiceQuotationsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListServiceQuotationsInfinite} query
 */
export const invalidateListServiceQuotationsInfinite = async (
 queryClient: QueryClient, params?: ListServiceQuotationsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListServiceQuotationsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListServiceQuotationsQueryOptions = <TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotations>>> = ({ signal }) => listServiceQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotations>>>
export type ListServiceQuotationsQueryError = ErrorType<unknown>


export function useListServiceQuotations<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotations>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotations<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotations>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotations<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations
 */

export function useListServiceQuotations<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service quotations
 */
export const prefetchListServiceQuotationsQuery = async <TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListServiceQuotationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListServiceQuotationsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListServiceQuotations} query
 */
export const invalidateListServiceQuotations = async (
 queryClient: QueryClient, params?: ListServiceQuotationsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListServiceQuotationsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListServiceQuotationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotations>>> = ({ signal }) => listServiceQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotations>>>
export type ListServiceQuotationsSuspenseQueryError = ErrorType<unknown>


export function useListServiceQuotationsSuspense<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsSuspense<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsSuspense<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations
 */

export function useListServiceQuotationsSuspense<TData = Awaited<ReturnType<typeof listServiceQuotations>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListServiceQuotationsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotations>>> = ({ signal }) => listServiceQuotations(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotations>>>
export type ListServiceQuotationsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListServiceQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations
 */

export function useListServiceQuotationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotations>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List service quotations eligible for purchase order issuance
 */
export const listServiceQuotationsForIssuance = (
    params?: ListServiceQuotationsForIssuanceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationIssueListResponse>(
      {url: `/api/v3/service_quotations/issue`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListServiceQuotationsForIssuanceInfiniteQueryKey = (params?: ListServiceQuotationsForIssuanceParams,) => {
    return [
    'infinite', `/api/v3/service_quotations/issue`, ...(params ? [params] : [])
    ] as const;
    }

export const getListServiceQuotationsForIssuanceQueryKey = (params?: ListServiceQuotationsForIssuanceParams,) => {
    return [
    `/api/v3/service_quotations/issue`, ...(params ? [params] : [])
    ] as const;
    }


export const useListServiceQuotationsForIssuanceInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsForIssuanceInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>> = ({ signal }) => listServiceQuotationsForIssuance(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsForIssuanceInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>
export type ListServiceQuotationsForIssuanceInfiniteQueryError = ErrorType<unknown>


export function useListServiceQuotationsForIssuanceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsForIssuanceParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuanceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuanceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations eligible for purchase order issuance
 */

export function useListServiceQuotationsForIssuanceInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsForIssuanceInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service quotations eligible for purchase order issuance
 */
export const prefetchListServiceQuotationsForIssuanceInfiniteQuery = async <TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListServiceQuotationsForIssuanceInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListServiceQuotationsForIssuanceInfinite} query
 */
export const invalidateListServiceQuotationsForIssuanceInfinite = async (
 queryClient: QueryClient, params?: ListServiceQuotationsForIssuanceParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListServiceQuotationsForIssuanceInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListServiceQuotationsForIssuanceQueryOptions = <TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsForIssuanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>> = ({ signal }) => listServiceQuotationsForIssuance(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsForIssuanceQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>
export type ListServiceQuotationsForIssuanceQueryError = ErrorType<unknown>


export function useListServiceQuotationsForIssuance<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsForIssuanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuance<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>,
          TError,
          Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuance<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations eligible for purchase order issuance
 */

export function useListServiceQuotationsForIssuance<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsForIssuanceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List service quotations eligible for purchase order issuance
 */
export const prefetchListServiceQuotationsForIssuanceQuery = async <TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListServiceQuotationsForIssuanceQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListServiceQuotationsForIssuance} query
 */
export const invalidateListServiceQuotationsForIssuance = async (
 queryClient: QueryClient, params?: ListServiceQuotationsForIssuanceParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListServiceQuotationsForIssuanceQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListServiceQuotationsForIssuanceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsForIssuanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>> = ({ signal }) => listServiceQuotationsForIssuance(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsForIssuanceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>
export type ListServiceQuotationsForIssuanceSuspenseQueryError = ErrorType<unknown>


export function useListServiceQuotationsForIssuanceSuspense<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsForIssuanceParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuanceSuspense<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuanceSuspense<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations eligible for purchase order issuance
 */

export function useListServiceQuotationsForIssuanceSuspense<TData = Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsForIssuanceSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListServiceQuotationsForIssuanceSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceQuotationsForIssuanceInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>> = ({ signal }) => listServiceQuotationsForIssuance(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListServiceQuotationsForIssuanceSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>
export type ListServiceQuotationsForIssuanceSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListServiceQuotationsForIssuanceSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListServiceQuotationsForIssuanceParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuanceSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListServiceQuotationsForIssuanceSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List service quotations eligible for purchase order issuance
 */

export function useListServiceQuotationsForIssuanceSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>>, TError = ErrorType<unknown>>(
 params?: ListServiceQuotationsForIssuanceParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listServiceQuotationsForIssuance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListServiceQuotationsForIssuanceSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Show a service quotation
 */
export const showServiceQuotation = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationDetail>(
      {url: `/api/v3/service_quotations/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowServiceQuotationInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/service_quotations/${id}`
    ] as const;
    }

export const getShowServiceQuotationQueryKey = (id: number,) => {
    return [
    `/api/v3/service_quotations/${id}`
    ] as const;
    }


export const useShowServiceQuotationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceQuotationInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceQuotation>>> = ({ signal }) => showServiceQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceQuotationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceQuotation>>>
export type ShowServiceQuotationInfiniteQueryError = ErrorType<unknown>


export function useShowServiceQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceQuotation>>,
          TError,
          Awaited<ReturnType<typeof showServiceQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceQuotation>>,
          TError,
          Awaited<ReturnType<typeof showServiceQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service quotation
 */

export function useShowServiceQuotationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceQuotationInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show a service quotation
 */
export const prefetchShowServiceQuotationInfiniteQuery = async <TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowServiceQuotationInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowServiceQuotationInfinite} query
 */
export const invalidateShowServiceQuotationInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowServiceQuotationInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowServiceQuotationQueryOptions = <TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceQuotationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceQuotation>>> = ({ signal }) => showServiceQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceQuotationQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceQuotation>>>
export type ShowServiceQuotationQueryError = ErrorType<unknown>


export function useShowServiceQuotation<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceQuotation>>,
          TError,
          Awaited<ReturnType<typeof showServiceQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotation<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showServiceQuotation>>,
          TError,
          Awaited<ReturnType<typeof showServiceQuotation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotation<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service quotation
 */

export function useShowServiceQuotation<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceQuotationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show a service quotation
 */
export const prefetchShowServiceQuotationQuery = async <TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowServiceQuotationQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowServiceQuotation} query
 */
export const invalidateShowServiceQuotation = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowServiceQuotationQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowServiceQuotationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceQuotationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceQuotation>>> = ({ signal }) => showServiceQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceQuotationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceQuotation>>>
export type ShowServiceQuotationSuspenseQueryError = ErrorType<unknown>


export function useShowServiceQuotationSuspense<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotationSuspense<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotationSuspense<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service quotation
 */

export function useShowServiceQuotationSuspense<TData = Awaited<ReturnType<typeof showServiceQuotation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceQuotationSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowServiceQuotationSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowServiceQuotationInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showServiceQuotation>>> = ({ signal }) => showServiceQuotation(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowServiceQuotationSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showServiceQuotation>>>
export type ShowServiceQuotationSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowServiceQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowServiceQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show a service quotation
 */

export function useShowServiceQuotationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showServiceQuotation>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showServiceQuotation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowServiceQuotationSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update a service quotation
 */
export const updateServiceQuotation = (
    id: number,
    updateServiceQuotationRequest?: UpdateServiceQuotationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationDetail>(
      {url: `/api/v3/service_quotations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateServiceQuotationRequest, signal
    },
      options);
    }




export const getUpdateServiceQuotationMutationKey = () => ['updateServiceQuotation'] as const;

export const getUpdateServiceQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceQuotation>>, TError,UpdateServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateServiceQuotation>>, TError,UpdateServiceQuotationMutationVariables, TContext> => {

const mutationKey = getUpdateServiceQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateServiceQuotation>>, UpdateServiceQuotationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateServiceQuotation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateServiceQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof updateServiceQuotation>>>
    export type UpdateServiceQuotationMutationBody = UpdateServiceQuotationRequest | undefined
    export type UpdateServiceQuotationMutationError = ErrorType<unknown>
    export type UpdateServiceQuotationMutationVariables = {id: number;data?: UpdateServiceQuotationRequest}

    /**
 * @summary Update a service quotation
 */
export const useUpdateServiceQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceQuotation>>, TError,UpdateServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateServiceQuotation>>,
        TError,
        UpdateServiceQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateServiceQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary Get available actions for a service quotation
 */
export const getServiceQuotationPossibleActions = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationPossibleActions>(
      {url: `/api/v3/service_quotations/${id}/possible_actions`, method: 'GET', signal
    },
      options);
    }




export const getGetServiceQuotationPossibleActionsInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/service_quotations/${id}/possible_actions`
    ] as const;
    }

export const getGetServiceQuotationPossibleActionsQueryKey = (id: number,) => {
    return [
    `/api/v3/service_quotations/${id}/possible_actions`
    ] as const;
    }


export const useGetServiceQuotationPossibleActionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationPossibleActionsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>> = ({ signal }) => getServiceQuotationPossibleActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationPossibleActionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>
export type GetServiceQuotationPossibleActionsInfiniteQueryError = ErrorType<unknown>


export function useGetServiceQuotationPossibleActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available actions for a service quotation
 */

export function useGetServiceQuotationPossibleActionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationPossibleActionsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get available actions for a service quotation
 */
export const prefetchGetServiceQuotationPossibleActionsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceQuotationPossibleActionsInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceQuotationPossibleActionsInfinite} query
 */
export const invalidateGetServiceQuotationPossibleActionsInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceQuotationPossibleActionsInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceQuotationPossibleActionsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationPossibleActionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>> = ({ signal }) => getServiceQuotationPossibleActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationPossibleActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>
export type GetServiceQuotationPossibleActionsQueryError = ErrorType<unknown>


export function useGetServiceQuotationPossibleActions<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActions<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActions<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available actions for a service quotation
 */

export function useGetServiceQuotationPossibleActions<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationPossibleActionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get available actions for a service quotation
 */
export const prefetchGetServiceQuotationPossibleActionsQuery = async <TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceQuotationPossibleActionsQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceQuotationPossibleActions} query
 */
export const invalidateGetServiceQuotationPossibleActions = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceQuotationPossibleActionsQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceQuotationPossibleActionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationPossibleActionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>> = ({ signal }) => getServiceQuotationPossibleActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationPossibleActionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>
export type GetServiceQuotationPossibleActionsSuspenseQueryError = ErrorType<unknown>


export function useGetServiceQuotationPossibleActionsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActionsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActionsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available actions for a service quotation
 */

export function useGetServiceQuotationPossibleActionsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationPossibleActionsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetServiceQuotationPossibleActionsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationPossibleActionsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>> = ({ signal }) => getServiceQuotationPossibleActions(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationPossibleActionsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>
export type GetServiceQuotationPossibleActionsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetServiceQuotationPossibleActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationPossibleActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available actions for a service quotation
 */

export function useGetServiceQuotationPossibleActionsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationPossibleActions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationPossibleActionsSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get activity logs for a service quotation
 */
export const getServiceQuotationActivityLogs = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationActivityLog[]>(
      {url: `/api/v3/service_quotations/${id}/activity_logs`, method: 'GET', signal
    },
      options);
    }




export const getGetServiceQuotationActivityLogsInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/service_quotations/${id}/activity_logs`
    ] as const;
    }

export const getGetServiceQuotationActivityLogsQueryKey = (id: number,) => {
    return [
    `/api/v3/service_quotations/${id}/activity_logs`
    ] as const;
    }


export const useGetServiceQuotationActivityLogsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationActivityLogsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>> = ({ signal }) => getServiceQuotationActivityLogs(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationActivityLogsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>
export type GetServiceQuotationActivityLogsInfiniteQueryError = ErrorType<unknown>


export function useGetServiceQuotationActivityLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get activity logs for a service quotation
 */

export function useGetServiceQuotationActivityLogsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationActivityLogsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get activity logs for a service quotation
 */
export const prefetchGetServiceQuotationActivityLogsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceQuotationActivityLogsInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceQuotationActivityLogsInfinite} query
 */
export const invalidateGetServiceQuotationActivityLogsInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceQuotationActivityLogsInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceQuotationActivityLogsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationActivityLogsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>> = ({ signal }) => getServiceQuotationActivityLogs(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationActivityLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>
export type GetServiceQuotationActivityLogsQueryError = ErrorType<unknown>


export function useGetServiceQuotationActivityLogs<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogs<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogs<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get activity logs for a service quotation
 */

export function useGetServiceQuotationActivityLogs<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationActivityLogsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get activity logs for a service quotation
 */
export const prefetchGetServiceQuotationActivityLogsQuery = async <TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceQuotationActivityLogsQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceQuotationActivityLogs} query
 */
export const invalidateGetServiceQuotationActivityLogs = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceQuotationActivityLogsQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceQuotationActivityLogsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationActivityLogsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>> = ({ signal }) => getServiceQuotationActivityLogs(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationActivityLogsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>
export type GetServiceQuotationActivityLogsSuspenseQueryError = ErrorType<unknown>


export function useGetServiceQuotationActivityLogsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get activity logs for a service quotation
 */

export function useGetServiceQuotationActivityLogsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationActivityLogsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetServiceQuotationActivityLogsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationActivityLogsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>> = ({ signal }) => getServiceQuotationActivityLogs(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationActivityLogsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>
export type GetServiceQuotationActivityLogsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetServiceQuotationActivityLogsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationActivityLogsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get activity logs for a service quotation
 */

export function useGetServiceQuotationActivityLogsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationActivityLogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationActivityLogsSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Upload or replace the scope of work attachment
 */
export const addServiceQuotationScopeOfWork = (
    id: number,
    addServiceQuotationScopeOfWorkRequest?: AddServiceQuotationScopeOfWorkRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationDetail>(
      {url: `/api/v3/service_quotations/${id}/scope_of_work`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addServiceQuotationScopeOfWorkRequest, signal
    },
      options);
    }




export const getAddServiceQuotationScopeOfWorkMutationKey = () => ['addServiceQuotationScopeOfWork'] as const;

export const getAddServiceQuotationScopeOfWorkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addServiceQuotationScopeOfWork>>, TError,AddServiceQuotationScopeOfWorkMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addServiceQuotationScopeOfWork>>, TError,AddServiceQuotationScopeOfWorkMutationVariables, TContext> => {

const mutationKey = getAddServiceQuotationScopeOfWorkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addServiceQuotationScopeOfWork>>, AddServiceQuotationScopeOfWorkMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addServiceQuotationScopeOfWork(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddServiceQuotationScopeOfWorkMutationResult = NonNullable<Awaited<ReturnType<typeof addServiceQuotationScopeOfWork>>>
    export type AddServiceQuotationScopeOfWorkMutationBody = AddServiceQuotationScopeOfWorkRequest | undefined
    export type AddServiceQuotationScopeOfWorkMutationError = ErrorType<unknown>
    export type AddServiceQuotationScopeOfWorkMutationVariables = {id: number;data?: AddServiceQuotationScopeOfWorkRequest}

    /**
 * @summary Upload or replace the scope of work attachment
 */
export const useAddServiceQuotationScopeOfWork = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addServiceQuotationScopeOfWork>>, TError,AddServiceQuotationScopeOfWorkMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addServiceQuotationScopeOfWork>>,
        TError,
        AddServiceQuotationScopeOfWorkMutationVariables,
        TContext
      > => {
      return useMutation(getAddServiceQuotationScopeOfWorkMutationOptions(options), queryClient);
    }
    /**
 * @summary Download the current scope of work file
 */
export const downloadServiceQuotationScopeOfWork = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/scope_of_work/download`, method: 'GET', signal
    },
      options);
    }




export const getDownloadServiceQuotationScopeOfWorkInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/service_quotations/${id}/scope_of_work/download`
    ] as const;
    }

export const getDownloadServiceQuotationScopeOfWorkQueryKey = (id: number,) => {
    return [
    `/api/v3/service_quotations/${id}/scope_of_work/download`
    ] as const;
    }


export const useDownloadServiceQuotationScopeOfWorkInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationScopeOfWorkInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>> = ({ signal }) => downloadServiceQuotationScopeOfWork(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationScopeOfWorkInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>
export type DownloadServiceQuotationScopeOfWorkInfiniteQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationScopeOfWorkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWorkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWorkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the current scope of work file
 */

export function useDownloadServiceQuotationScopeOfWorkInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationScopeOfWorkInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download the current scope of work file
 */
export const prefetchDownloadServiceQuotationScopeOfWorkInfiniteQuery = async <TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadServiceQuotationScopeOfWorkInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadServiceQuotationScopeOfWorkInfinite} query
 */
export const invalidateDownloadServiceQuotationScopeOfWorkInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadServiceQuotationScopeOfWorkInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useDownloadServiceQuotationScopeOfWorkQueryOptions = <TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationScopeOfWorkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>> = ({ signal }) => downloadServiceQuotationScopeOfWork(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationScopeOfWorkQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>
export type DownloadServiceQuotationScopeOfWorkQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationScopeOfWork<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWork<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWork<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the current scope of work file
 */

export function useDownloadServiceQuotationScopeOfWork<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationScopeOfWorkQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download the current scope of work file
 */
export const prefetchDownloadServiceQuotationScopeOfWorkQuery = async <TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadServiceQuotationScopeOfWorkQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadServiceQuotationScopeOfWork} query
 */
export const invalidateDownloadServiceQuotationScopeOfWork = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadServiceQuotationScopeOfWorkQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useDownloadServiceQuotationScopeOfWorkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationScopeOfWorkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>> = ({ signal }) => downloadServiceQuotationScopeOfWork(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationScopeOfWorkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>
export type DownloadServiceQuotationScopeOfWorkSuspenseQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationScopeOfWorkSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWorkSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWorkSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the current scope of work file
 */

export function useDownloadServiceQuotationScopeOfWorkSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationScopeOfWorkSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useDownloadServiceQuotationScopeOfWorkSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationScopeOfWorkInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>> = ({ signal }) => downloadServiceQuotationScopeOfWork(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationScopeOfWorkSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>
export type DownloadServiceQuotationScopeOfWorkSuspenseInfiniteQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationScopeOfWorkSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWorkSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationScopeOfWorkSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the current scope of work file
 */

export function useDownloadServiceQuotationScopeOfWorkSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationScopeOfWork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationScopeOfWorkSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Download the service quotation proposals comparison spreadsheet
 */
export const downloadServiceQuotationProposalsComparison = (
    id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/proposals_comparison`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDownloadServiceQuotationProposalsComparisonInfiniteQueryKey = (id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams,) => {
    return [
    'infinite', `/api/v3/service_quotations/${id}/proposals_comparison`, ...(params ? [params] : [])
    ] as const;
    }

export const getDownloadServiceQuotationProposalsComparisonQueryKey = (id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams,) => {
    return [
    `/api/v3/service_quotations/${id}/proposals_comparison`, ...(params ? [params] : [])
    ] as const;
    }


export const useDownloadServiceQuotationProposalsComparisonInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationProposalsComparisonInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>> = ({ signal }) => downloadServiceQuotationProposalsComparison(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationProposalsComparisonInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>
export type DownloadServiceQuotationProposalsComparisonInfiniteQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationProposalsComparisonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  DownloadServiceQuotationProposalsComparisonParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparisonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparisonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the service quotation proposals comparison spreadsheet
 */

export function useDownloadServiceQuotationProposalsComparisonInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationProposalsComparisonInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download the service quotation proposals comparison spreadsheet
 */
export const prefetchDownloadServiceQuotationProposalsComparisonInfiniteQuery = async <TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadServiceQuotationProposalsComparisonInfiniteQueryOptions(id,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadServiceQuotationProposalsComparisonInfinite} query
 */
export const invalidateDownloadServiceQuotationProposalsComparisonInfinite = async (
 queryClient: QueryClient, id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadServiceQuotationProposalsComparisonInfiniteQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useDownloadServiceQuotationProposalsComparisonQueryOptions = <TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationProposalsComparisonQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>> = ({ signal }) => downloadServiceQuotationProposalsComparison(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationProposalsComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>
export type DownloadServiceQuotationProposalsComparisonQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationProposalsComparison<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  DownloadServiceQuotationProposalsComparisonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparison<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparison<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the service quotation proposals comparison spreadsheet
 */

export function useDownloadServiceQuotationProposalsComparison<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationProposalsComparisonQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Download the service quotation proposals comparison spreadsheet
 */
export const prefetchDownloadServiceQuotationProposalsComparisonQuery = async <TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadServiceQuotationProposalsComparisonQueryOptions(id,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadServiceQuotationProposalsComparison} query
 */
export const invalidateDownloadServiceQuotationProposalsComparison = async (
 queryClient: QueryClient, id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadServiceQuotationProposalsComparisonQueryKey(id,params) }).queryKey }, options);

  return queryClient;
}




export const useDownloadServiceQuotationProposalsComparisonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationProposalsComparisonQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>> = ({ signal }) => downloadServiceQuotationProposalsComparison(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationProposalsComparisonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>
export type DownloadServiceQuotationProposalsComparisonSuspenseQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationProposalsComparisonSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  DownloadServiceQuotationProposalsComparisonParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparisonSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparisonSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the service quotation proposals comparison spreadsheet
 */

export function useDownloadServiceQuotationProposalsComparisonSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationProposalsComparisonSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useDownloadServiceQuotationProposalsComparisonSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationProposalsComparisonInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>> = ({ signal }) => downloadServiceQuotationProposalsComparison(id,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationProposalsComparisonSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>
export type DownloadServiceQuotationProposalsComparisonSuspenseInfiniteQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationProposalsComparisonSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  DownloadServiceQuotationProposalsComparisonParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparisonSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationProposalsComparisonSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the service quotation proposals comparison spreadsheet
 */

export function useDownloadServiceQuotationProposalsComparisonSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>>, TError = ErrorType<unknown>>(
 id: number,
    params?: DownloadServiceQuotationProposalsComparisonParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationProposalsComparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationProposalsComparisonSuspenseInfiniteQueryOptions(id,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add a document to a service quotation
 */
export const addServiceQuotationDocument = (
    id: number,
    addServiceQuotationDocumentRequest?: AddServiceQuotationDocumentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationDocument[]>(
      {url: `/api/v3/service_quotations/${id}/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addServiceQuotationDocumentRequest, signal
    },
      options);
    }




export const getAddServiceQuotationDocumentMutationKey = () => ['addServiceQuotationDocument'] as const;

export const getAddServiceQuotationDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addServiceQuotationDocument>>, TError,AddServiceQuotationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addServiceQuotationDocument>>, TError,AddServiceQuotationDocumentMutationVariables, TContext> => {

const mutationKey = getAddServiceQuotationDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addServiceQuotationDocument>>, AddServiceQuotationDocumentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addServiceQuotationDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddServiceQuotationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof addServiceQuotationDocument>>>
    export type AddServiceQuotationDocumentMutationBody = AddServiceQuotationDocumentRequest | undefined
    export type AddServiceQuotationDocumentMutationError = ErrorType<unknown>
    export type AddServiceQuotationDocumentMutationVariables = {id: number;data?: AddServiceQuotationDocumentRequest}

    /**
 * @summary Add a document to a service quotation
 */
export const useAddServiceQuotationDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addServiceQuotationDocument>>, TError,AddServiceQuotationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addServiceQuotationDocument>>,
        TError,
        AddServiceQuotationDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getAddServiceQuotationDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary List documents for a service quotation
 */
export const getServiceQuotationDocuments = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationDocument[]>(
      {url: `/api/v3/service_quotations/${id}/documents`, method: 'GET', signal
    },
      options);
    }




export const getGetServiceQuotationDocumentsInfiniteQueryKey = (id: number,) => {
    return [
    'infinite', `/api/v3/service_quotations/${id}/documents`
    ] as const;
    }

export const getGetServiceQuotationDocumentsQueryKey = (id: number,) => {
    return [
    `/api/v3/service_quotations/${id}/documents`
    ] as const;
    }


export const useGetServiceQuotationDocumentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationDocumentsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationDocuments>>> = ({ signal }) => getServiceQuotationDocuments(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationDocumentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>
export type GetServiceQuotationDocumentsInfiniteQueryError = ErrorType<unknown>


export function useGetServiceQuotationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List documents for a service quotation
 */

export function useGetServiceQuotationDocumentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationDocumentsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List documents for a service quotation
 */
export const prefetchGetServiceQuotationDocumentsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceQuotationDocumentsInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceQuotationDocumentsInfinite} query
 */
export const invalidateGetServiceQuotationDocumentsInfinite = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceQuotationDocumentsInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceQuotationDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationDocuments>>> = ({ signal }) => getServiceQuotationDocuments(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>
export type GetServiceQuotationDocumentsQueryError = ErrorType<unknown>


export function useGetServiceQuotationDocuments<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocuments<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>,
          TError,
          Awaited<ReturnType<typeof getServiceQuotationDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocuments<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List documents for a service quotation
 */

export function useGetServiceQuotationDocuments<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List documents for a service quotation
 */
export const prefetchGetServiceQuotationDocumentsQuery = async <TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useGetServiceQuotationDocumentsQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useGetServiceQuotationDocuments} query
 */
export const invalidateGetServiceQuotationDocuments = async (
 queryClient: QueryClient, id: number, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getGetServiceQuotationDocumentsQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useGetServiceQuotationDocumentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationDocuments>>> = ({ signal }) => getServiceQuotationDocuments(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationDocumentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>
export type GetServiceQuotationDocumentsSuspenseQueryError = ErrorType<unknown>


export function useGetServiceQuotationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List documents for a service quotation
 */

export function useGetServiceQuotationDocumentsSuspense<TData = Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationDocumentsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useGetServiceQuotationDocumentsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQuotationDocumentsInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceQuotationDocuments>>> = ({ signal }) => getServiceQuotationDocuments(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQuotationDocumentsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>
export type GetServiceQuotationDocumentsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useGetServiceQuotationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceQuotationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List documents for a service quotation
 */

export function useGetServiceQuotationDocumentsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServiceQuotationDocuments>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServiceQuotationDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetServiceQuotationDocumentsSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a service quotation document download URL
 */
export const downloadServiceQuotationDocument = (
    id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationDocument>(
      {url: `/api/v3/service_quotations/${id}/documents/${documentId}/download`, method: 'GET',
        params, signal
    },
      options);
    }




export const getDownloadServiceQuotationDocumentInfiniteQueryKey = (id: number,
    documentId: number,
    params?: DownloadServiceQuotationDocumentParams,) => {
    return [
    'infinite', `/api/v3/service_quotations/${id}/documents/${documentId}/download`, ...(params ? [params] : [])
    ] as const;
    }

export const getDownloadServiceQuotationDocumentQueryKey = (id: number,
    documentId: number,
    params?: DownloadServiceQuotationDocumentParams,) => {
    return [
    `/api/v3/service_quotations/${id}/documents/${documentId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const useDownloadServiceQuotationDocumentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationDocumentInfiniteQueryKey(id,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>> = ({ signal }) => downloadServiceQuotationDocument(id,documentId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationDocumentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>
export type DownloadServiceQuotationDocumentInfiniteQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a service quotation document download URL
 */

export function useDownloadServiceQuotationDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationDocumentInfiniteQueryOptions(id,documentId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a service quotation document download URL
 */
export const prefetchDownloadServiceQuotationDocumentInfiniteQuery = async <TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadServiceQuotationDocumentInfiniteQueryOptions(id,documentId,params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadServiceQuotationDocumentInfinite} query
 */
export const invalidateDownloadServiceQuotationDocumentInfinite = async (
 queryClient: QueryClient, id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadServiceQuotationDocumentInfiniteQueryKey(id,documentId,params) }).queryKey }, options);

  return queryClient;
}




export const useDownloadServiceQuotationDocumentQueryOptions = <TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationDocumentQueryKey(id,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>> = ({ signal }) => downloadServiceQuotationDocument(id,documentId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined && documentId !== null && documentId !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>
export type DownloadServiceQuotationDocumentQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationDocument<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocument<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>,
          TError,
          Awaited<ReturnType<typeof downloadServiceQuotationDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocument<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a service quotation document download URL
 */

export function useDownloadServiceQuotationDocument<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationDocumentQueryOptions(id,documentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a service quotation document download URL
 */
export const prefetchDownloadServiceQuotationDocumentQuery = async <TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useDownloadServiceQuotationDocumentQueryOptions(id,documentId,params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useDownloadServiceQuotationDocument} query
 */
export const invalidateDownloadServiceQuotationDocument = async (
 queryClient: QueryClient, id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getDownloadServiceQuotationDocumentQueryKey(id,documentId,params) }).queryKey }, options);

  return queryClient;
}




export const useDownloadServiceQuotationDocumentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationDocumentQueryKey(id,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>> = ({ signal }) => downloadServiceQuotationDocument(id,documentId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationDocumentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>
export type DownloadServiceQuotationDocumentSuspenseQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationDocumentSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocumentSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocumentSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a service quotation document download URL
 */

export function useDownloadServiceQuotationDocumentSuspense<TData = Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationDocumentSuspenseQueryOptions(id,documentId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useDownloadServiceQuotationDocumentSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadServiceQuotationDocumentInfiniteQueryKey(id,documentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>> = ({ signal }) => downloadServiceQuotationDocument(id,documentId,params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadServiceQuotationDocumentSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>
export type DownloadServiceQuotationDocumentSuspenseInfiniteQueryError = ErrorType<unknown>


export function useDownloadServiceQuotationDocumentSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocumentSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadServiceQuotationDocumentSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a service quotation document download URL
 */

export function useDownloadServiceQuotationDocumentSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>>, TError = ErrorType<unknown>>(
 id: number,
    documentId: number,
    params: DownloadServiceQuotationDocumentParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof downloadServiceQuotationDocument>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useDownloadServiceQuotationDocumentSuspenseInfiniteQueryOptions(id,documentId,params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Remove a document from a service quotation
 */
export const removeServiceQuotationDocument = (
    id: number,
    documentId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationActionResult>(
      {url: `/api/v3/service_quotations/${id}/documents/${documentId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveServiceQuotationDocumentMutationKey = () => ['removeServiceQuotationDocument'] as const;

export const getRemoveServiceQuotationDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeServiceQuotationDocument>>, TError,RemoveServiceQuotationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeServiceQuotationDocument>>, TError,RemoveServiceQuotationDocumentMutationVariables, TContext> => {

const mutationKey = getRemoveServiceQuotationDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeServiceQuotationDocument>>, RemoveServiceQuotationDocumentMutationVariables> = (props) => {
          const {id,documentId} = props ?? {};

          return  removeServiceQuotationDocument(id,documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveServiceQuotationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof removeServiceQuotationDocument>>>

    export type RemoveServiceQuotationDocumentMutationError = ErrorType<unknown>
    export type RemoveServiceQuotationDocumentMutationVariables = {id: number;documentId: number}

    /**
 * @summary Remove a document from a service quotation
 */
export const useRemoveServiceQuotationDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeServiceQuotationDocument>>, TError,RemoveServiceQuotationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeServiceQuotationDocument>>,
        TError,
        RemoveServiceQuotationDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveServiceQuotationDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Set a scope of work document as main
 */
export const setMainServiceQuotationDocument = (
    id: number,
    documentId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationActionResult>(
      {url: `/api/v3/service_quotations/${id}/documents/${documentId}/set_as_main`, method: 'PUT', signal
    },
      options);
    }




export const getSetMainServiceQuotationDocumentMutationKey = () => ['setMainServiceQuotationDocument'] as const;

export const getSetMainServiceQuotationDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMainServiceQuotationDocument>>, TError,SetMainServiceQuotationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setMainServiceQuotationDocument>>, TError,SetMainServiceQuotationDocumentMutationVariables, TContext> => {

const mutationKey = getSetMainServiceQuotationDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMainServiceQuotationDocument>>, SetMainServiceQuotationDocumentMutationVariables> = (props) => {
          const {id,documentId} = props ?? {};

          return  setMainServiceQuotationDocument(id,documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMainServiceQuotationDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof setMainServiceQuotationDocument>>>

    export type SetMainServiceQuotationDocumentMutationError = ErrorType<unknown>
    export type SetMainServiceQuotationDocumentMutationVariables = {id: number;documentId: number}

    /**
 * @summary Set a scope of work document as main
 */
export const useSetMainServiceQuotationDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMainServiceQuotationDocument>>, TError,SetMainServiceQuotationDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setMainServiceQuotationDocument>>,
        TError,
        SetMainServiceQuotationDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getSetMainServiceQuotationDocumentMutationOptions(options), queryClient);
    }
    /**
 * @summary Invite vendors to a service quotation
 */
export const inviteServiceQuotationVendors = (
    id: number,
    inviteServiceQuotationVendorsRequest: InviteServiceQuotationVendorsRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationVendorInvitationResult>(
      {url: `/api/v3/service_quotations/${id}/invite_vendors`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteServiceQuotationVendorsRequest, signal
    },
      options);
    }




export const getInviteServiceQuotationVendorsMutationKey = () => ['inviteServiceQuotationVendors'] as const;

export const getInviteServiceQuotationVendorsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteServiceQuotationVendors>>, TError,InviteServiceQuotationVendorsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteServiceQuotationVendors>>, TError,InviteServiceQuotationVendorsMutationVariables, TContext> => {

const mutationKey = getInviteServiceQuotationVendorsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteServiceQuotationVendors>>, InviteServiceQuotationVendorsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  inviteServiceQuotationVendors(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteServiceQuotationVendorsMutationResult = NonNullable<Awaited<ReturnType<typeof inviteServiceQuotationVendors>>>
    export type InviteServiceQuotationVendorsMutationBody = InviteServiceQuotationVendorsRequest
    export type InviteServiceQuotationVendorsMutationError = ErrorType<unknown>
    export type InviteServiceQuotationVendorsMutationVariables = {id: number;data: InviteServiceQuotationVendorsRequest}

    /**
 * @summary Invite vendors to a service quotation
 */
export const useInviteServiceQuotationVendors = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteServiceQuotationVendors>>, TError,InviteServiceQuotationVendorsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteServiceQuotationVendors>>,
        TError,
        InviteServiceQuotationVendorsMutationVariables,
        TContext
      > => {
      return useMutation(getInviteServiceQuotationVendorsMutationOptions(options), queryClient);
    }
    /**
 * @summary Reopen offer window
 */
export const reopenServiceQuotationOfferWindow = (
    id: number,
    reopenServiceQuotationOfferWindowRequest: ReopenServiceQuotationOfferWindowRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/reopen_offer_window`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reopenServiceQuotationOfferWindowRequest, signal
    },
      options);
    }




export const getReopenServiceQuotationOfferWindowMutationKey = () => ['reopenServiceQuotationOfferWindow'] as const;

export const getReopenServiceQuotationOfferWindowMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenServiceQuotationOfferWindow>>, TError,ReopenServiceQuotationOfferWindowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenServiceQuotationOfferWindow>>, TError,ReopenServiceQuotationOfferWindowMutationVariables, TContext> => {

const mutationKey = getReopenServiceQuotationOfferWindowMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenServiceQuotationOfferWindow>>, ReopenServiceQuotationOfferWindowMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  reopenServiceQuotationOfferWindow(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenServiceQuotationOfferWindowMutationResult = NonNullable<Awaited<ReturnType<typeof reopenServiceQuotationOfferWindow>>>
    export type ReopenServiceQuotationOfferWindowMutationBody = ReopenServiceQuotationOfferWindowRequest
    export type ReopenServiceQuotationOfferWindowMutationError = ErrorType<unknown>
    export type ReopenServiceQuotationOfferWindowMutationVariables = {id: number;data: ReopenServiceQuotationOfferWindowRequest}

    /**
 * @summary Reopen offer window
 */
export const useReopenServiceQuotationOfferWindow = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenServiceQuotationOfferWindow>>, TError,ReopenServiceQuotationOfferWindowMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenServiceQuotationOfferWindow>>,
        TError,
        ReopenServiceQuotationOfferWindowMutationVariables,
        TContext
      > => {
      return useMutation(getReopenServiceQuotationOfferWindowMutationOptions(options), queryClient);
    }
    /**
 * @summary Evaluate offers
 */
export const evaluateServiceQuotationOffers = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/evaluate_offers`, method: 'POST', signal
    },
      options);
    }




export const getEvaluateServiceQuotationOffersMutationKey = () => ['evaluateServiceQuotationOffers'] as const;

export const getEvaluateServiceQuotationOffersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateServiceQuotationOffers>>, TError,EvaluateServiceQuotationOffersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluateServiceQuotationOffers>>, TError,EvaluateServiceQuotationOffersMutationVariables, TContext> => {

const mutationKey = getEvaluateServiceQuotationOffersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluateServiceQuotationOffers>>, EvaluateServiceQuotationOffersMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  evaluateServiceQuotationOffers(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EvaluateServiceQuotationOffersMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateServiceQuotationOffers>>>

    export type EvaluateServiceQuotationOffersMutationError = ErrorType<unknown>
    export type EvaluateServiceQuotationOffersMutationVariables = {id: number}

    /**
 * @summary Evaluate offers
 */
export const useEvaluateServiceQuotationOffers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateServiceQuotationOffers>>, TError,EvaluateServiceQuotationOffersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evaluateServiceQuotationOffers>>,
        TError,
        EvaluateServiceQuotationOffersMutationVariables,
        TContext
      > => {
      return useMutation(getEvaluateServiceQuotationOffersMutationOptions(options), queryClient);
    }
    /**
 * @summary Open renegotiation for a service quotation
 */
export const openServiceQuotationRenegotiation = (
    id: number,
    openServiceQuotationRenegotiationRequest: OpenServiceQuotationRenegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/open_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openServiceQuotationRenegotiationRequest, signal
    },
      options);
    }




export const getOpenServiceQuotationRenegotiationMutationKey = () => ['openServiceQuotationRenegotiation'] as const;

export const getOpenServiceQuotationRenegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openServiceQuotationRenegotiation>>, TError,OpenServiceQuotationRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof openServiceQuotationRenegotiation>>, TError,OpenServiceQuotationRenegotiationMutationVariables, TContext> => {

const mutationKey = getOpenServiceQuotationRenegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openServiceQuotationRenegotiation>>, OpenServiceQuotationRenegotiationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  openServiceQuotationRenegotiation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenServiceQuotationRenegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof openServiceQuotationRenegotiation>>>
    export type OpenServiceQuotationRenegotiationMutationBody = OpenServiceQuotationRenegotiationRequest
    export type OpenServiceQuotationRenegotiationMutationError = ErrorType<unknown>
    export type OpenServiceQuotationRenegotiationMutationVariables = {id: number;data: OpenServiceQuotationRenegotiationRequest}

    /**
 * @summary Open renegotiation for a service quotation
 */
export const useOpenServiceQuotationRenegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openServiceQuotationRenegotiation>>, TError,OpenServiceQuotationRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openServiceQuotationRenegotiation>>,
        TError,
        OpenServiceQuotationRenegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getOpenServiceQuotationRenegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Close renegotiation for a service quotation
 */
export const closeServiceQuotationRenegotiation = (
    id: number,
    closeServiceQuotationRenegotiationRequest: CloseServiceQuotationRenegotiationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/close_renegotiation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: closeServiceQuotationRenegotiationRequest, signal
    },
      options);
    }




export const getCloseServiceQuotationRenegotiationMutationKey = () => ['closeServiceQuotationRenegotiation'] as const;

export const getCloseServiceQuotationRenegotiationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeServiceQuotationRenegotiation>>, TError,CloseServiceQuotationRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof closeServiceQuotationRenegotiation>>, TError,CloseServiceQuotationRenegotiationMutationVariables, TContext> => {

const mutationKey = getCloseServiceQuotationRenegotiationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeServiceQuotationRenegotiation>>, CloseServiceQuotationRenegotiationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  closeServiceQuotationRenegotiation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseServiceQuotationRenegotiationMutationResult = NonNullable<Awaited<ReturnType<typeof closeServiceQuotationRenegotiation>>>
    export type CloseServiceQuotationRenegotiationMutationBody = CloseServiceQuotationRenegotiationRequest
    export type CloseServiceQuotationRenegotiationMutationError = ErrorType<unknown>
    export type CloseServiceQuotationRenegotiationMutationVariables = {id: number;data: CloseServiceQuotationRenegotiationRequest}

    /**
 * @summary Close renegotiation for a service quotation
 */
export const useCloseServiceQuotationRenegotiation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeServiceQuotationRenegotiation>>, TError,CloseServiceQuotationRenegotiationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeServiceQuotationRenegotiation>>,
        TError,
        CloseServiceQuotationRenegotiationMutationVariables,
        TContext
      > => {
      return useMutation(getCloseServiceQuotationRenegotiationMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove create purchase order association from service quotation
 */
export const removeCreatePurchaseOrderByServiceQuotation = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/create_purchase_order_by_service_quotation`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveCreatePurchaseOrderByServiceQuotationMutationKey = () => ['removeCreatePurchaseOrderByServiceQuotation'] as const;

export const getRemoveCreatePurchaseOrderByServiceQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCreatePurchaseOrderByServiceQuotation>>, TError,RemoveCreatePurchaseOrderByServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCreatePurchaseOrderByServiceQuotation>>, TError,RemoveCreatePurchaseOrderByServiceQuotationMutationVariables, TContext> => {

const mutationKey = getRemoveCreatePurchaseOrderByServiceQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCreatePurchaseOrderByServiceQuotation>>, RemoveCreatePurchaseOrderByServiceQuotationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  removeCreatePurchaseOrderByServiceQuotation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCreatePurchaseOrderByServiceQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof removeCreatePurchaseOrderByServiceQuotation>>>

    export type RemoveCreatePurchaseOrderByServiceQuotationMutationError = ErrorType<unknown>
    export type RemoveCreatePurchaseOrderByServiceQuotationMutationVariables = {id: number}

    /**
 * @summary Remove create purchase order association from service quotation
 */
export const useRemoveCreatePurchaseOrderByServiceQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCreatePurchaseOrderByServiceQuotation>>, TError,RemoveCreatePurchaseOrderByServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCreatePurchaseOrderByServiceQuotation>>,
        TError,
        RemoveCreatePurchaseOrderByServiceQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveCreatePurchaseOrderByServiceQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel a service quotation
 */
export const cancelServiceQuotation = (
    id: number,
    cancelServiceQuotationRequest: CancelServiceQuotationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelServiceQuotationRequest, signal
    },
      options);
    }




export const getCancelServiceQuotationMutationKey = () => ['cancelServiceQuotation'] as const;

export const getCancelServiceQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelServiceQuotation>>, TError,CancelServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelServiceQuotation>>, TError,CancelServiceQuotationMutationVariables, TContext> => {

const mutationKey = getCancelServiceQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelServiceQuotation>>, CancelServiceQuotationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  cancelServiceQuotation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelServiceQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelServiceQuotation>>>
    export type CancelServiceQuotationMutationBody = CancelServiceQuotationRequest
    export type CancelServiceQuotationMutationError = ErrorType<unknown>
    export type CancelServiceQuotationMutationVariables = {id: number;data: CancelServiceQuotationRequest}

    /**
 * @summary Cancel a service quotation
 */
export const useCancelServiceQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelServiceQuotation>>, TError,CancelServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelServiceQuotation>>,
        TError,
        CancelServiceQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getCancelServiceQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary Refuse a service quotation
 */
export const refuseServiceQuotation = (
    id: number,
    refuseServiceQuotationRequest: RefuseServiceQuotationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/v3/service_quotations/${id}/refuse`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refuseServiceQuotationRequest, signal
    },
      options);
    }




export const getRefuseServiceQuotationMutationKey = () => ['refuseServiceQuotation'] as const;

export const getRefuseServiceQuotationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refuseServiceQuotation>>, TError,RefuseServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refuseServiceQuotation>>, TError,RefuseServiceQuotationMutationVariables, TContext> => {

const mutationKey = getRefuseServiceQuotationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refuseServiceQuotation>>, RefuseServiceQuotationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  refuseServiceQuotation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefuseServiceQuotationMutationResult = NonNullable<Awaited<ReturnType<typeof refuseServiceQuotation>>>
    export type RefuseServiceQuotationMutationBody = RefuseServiceQuotationRequest
    export type RefuseServiceQuotationMutationError = ErrorType<unknown>
    export type RefuseServiceQuotationMutationVariables = {id: number;data: RefuseServiceQuotationRequest}

    /**
 * @summary Refuse a service quotation
 */
export const useRefuseServiceQuotation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refuseServiceQuotation>>, TError,RefuseServiceQuotationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refuseServiceQuotation>>,
        TError,
        RefuseServiceQuotationMutationVariables,
        TContext
      > => {
      return useMutation(getRefuseServiceQuotationMutationOptions(options), queryClient);
    }
    /**
 * @summary Request anticipation for a service quotation
 */
export const requestServiceQuotationAnticipation = (
    id: number,
    requestServiceQuotationAnticipationRequest: RequestServiceQuotationAnticipationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesServiceQuotationActionResult>(
      {url: `/api/v3/service_quotations/${id}/request_anticipation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestServiceQuotationAnticipationRequest, signal
    },
      options);
    }




export const getRequestServiceQuotationAnticipationMutationKey = () => ['requestServiceQuotationAnticipation'] as const;

export const getRequestServiceQuotationAnticipationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestServiceQuotationAnticipation>>, TError,RequestServiceQuotationAnticipationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestServiceQuotationAnticipation>>, TError,RequestServiceQuotationAnticipationMutationVariables, TContext> => {

const mutationKey = getRequestServiceQuotationAnticipationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestServiceQuotationAnticipation>>, RequestServiceQuotationAnticipationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  requestServiceQuotationAnticipation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestServiceQuotationAnticipationMutationResult = NonNullable<Awaited<ReturnType<typeof requestServiceQuotationAnticipation>>>
    export type RequestServiceQuotationAnticipationMutationBody = RequestServiceQuotationAnticipationRequest
    export type RequestServiceQuotationAnticipationMutationError = ErrorType<unknown>
    export type RequestServiceQuotationAnticipationMutationVariables = {id: number;data: RequestServiceQuotationAnticipationRequest}

    /**
 * @summary Request anticipation for a service quotation
 */
export const useRequestServiceQuotationAnticipation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestServiceQuotationAnticipation>>, TError,RequestServiceQuotationAnticipationMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestServiceQuotationAnticipation>>,
        TError,
        RequestServiceQuotationAnticipationMutationVariables,
        TContext
      > => {
      return useMutation(getRequestServiceQuotationAnticipationMutationOptions(options), queryClient);
    }
